
import EmergencyApi from '../../plugins/emergency/src/apis';
import CommonApi from '../../api/src/file-api';
export default{
    EmergencyApi,
    ...CommonApi
} ;